import type { InputHTMLAttributes, ReactNode } from 'react'

export type RadioPreviewState = 'default' | 'hover' | 'focused' | 'disabled'

export type RadioValueState = 'unchecked' | 'checked'

export const RADIO_PREVIEW_STATES: RadioPreviewState[] = [
  'default',
  'hover',
  'focused',
  'disabled',
]

export const RADIO_PREVIEW_STATE_LABELS: Record<RadioPreviewState, string> = {
  default: 'Default',
  hover: 'Hover',
  focused: 'Focused',
  disabled: 'Disabled',
}

export const RADIO_VALUE_STATES: RadioValueState[] = ['unchecked', 'checked']

export const RADIO_VALUE_STATE_LABELS: Record<RadioValueState, string> = {
  unchecked: 'Unchecked',
  checked: 'Checked',
}

export type RadioProps = {
  label?: ReactNode
  value: string
  className?: string
  /** Dark surface styling. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: RadioPreviewState
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value'>

export type RadioOption = {
  value: string
  label: ReactNode
  disabled?: boolean
}

export type RadioGroupProps = {
  name?: string
  value?: string
  defaultValue?: string
  label?: ReactNode
  options?: RadioOption[]
  disabled?: boolean
  orientation?: 'vertical' | 'horizontal'
  className?: string
  /** Dark surface styling; passed through to child radios. */
  darkMode?: boolean
  onChange?: (value: string) => void
  children?: ReactNode
}
